import { Note, NoteType, isTeamspaceNote } from './note'

// Define a minimal interface that has the properties needed for team space lookup
export interface TeamSpaceIdentifiable {
  recordName: string
  noteType: NoteType
  parent: string | null
}

export function getTeamSpace(
  teamProjectNotesMap: Map<string, Note> | undefined,
  note: Note | TeamSpaceIdentifiable
): Note | undefined {
  if (!teamProjectNotesMap) {
    return
  }
  if (!isTeamspaceNote(note.noteType)) {
    return
  }
  if (note.noteType === NoteType.TEAM_SPACE) {
    return teamProjectNotesMap.get(note.recordName)
  }
  const parentNote = note.parent
    ? teamProjectNotesMap.get(note.parent)
    : undefined
  return parentNote ? getTeamSpace(teamProjectNotesMap, parentNote) : undefined
}

export function getTeamSpaceTitle(
  teamProjectNotesMap: Map<string, Note>,
  note: Note | TeamSpaceIdentifiable
) {
  const teamSpace = getTeamSpace(teamProjectNotesMap, note)
  return teamSpace ? teamSpace.title : undefined
}
